var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneGraspIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37259 5.64251L2.37251 5.64245C1.01427 7.25849 0.719528 8.78667 1.12654 10.0615C1.5399 11.3562 2.71834 12.5219 4.57837 13.3021L4.58014 13.3028C9.06319 15.2034 14.0824 12.7596 15.5532 7.6711C15.8701 6.46101 16.4539 4.13144 15.1215 2.29503L15.1175 2.28946L15.1175 2.28944C14.7617 1.78455 14.3025 1.36374 13.7716 1.05548C13.2437 0.748924 12.6571 0.560784 12.0515 0.503483C11.513 0.477163 11.1522 0.59728 10.6419 0.896542C10.4086 1.0334 10.1547 1.20149 9.83972 1.41C9.78902 1.44357 9.73673 1.47818 9.68269 1.51388C9.29805 1.76801 8.83983 2.06679 8.27059 2.40526L2.37259 5.64251ZM2.37259 5.64251L2.37886 5.63474M2.37259 5.64251L2.37886 5.63474M2.37886 5.63474C3.00163 4.863 3.49125 4.62014 4.31863 4.29258M2.37886 5.63474L4.31863 4.29258M4.31863 4.29258C4.4125 4.25541 4.51023 4.21737 4.6123 4.17765M4.31863 4.29258L4.6123 4.17765M4.6123 4.17765C5.45069 3.85134 6.5815 3.41123 8.27043 2.40535L4.6123 4.17765Z",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGraspIcon);
export default __webpack_public_path__ + "static/media/phone_grasp_icon.562b7eb61cb4cda7dff31c483e3b24bf.svg";
export { ForwardRef as ReactComponent };